module.exports = __webpack_public_path__ + "2ac6aeae910d93f6092789f3d113ab9c.glb";